import * as helpAndLearningAPI from "../../api/helpAndLearningAPI";
import * as profileApi from "../../api/profileApi";
import store from "../../store/store";
//
const termsAndConditionsModel = {
  state: {
    showTacModal: false,
    html: "",
    versionTermsAndConditions: "",
  },
  reducers: {
    setShowTacModal(state: Record<string, any>, payload: boolean) {
      return { ...state, showTacModal: payload };
    },
    setHtmlAndVersionTermsAndConditions(
      state: Record<string, any>,
      payload: any
    ): any {
      return {
        ...state,
        html: payload.html,
        versionTermsAndConditions: payload.versionTermsAndConditions,
      };
    },
  },
  effects: {
    async setTacAccepted(session: any) {
      const versionTermsAndConditions =
        store.getState().termsAndConditionsModel.versionTermsAndConditions;
      profileApi
        .updateTAC(
          session["userId"],
          session["accountId"],
          true,
          versionTermsAndConditions
        )
        .then((resp: { [x: string]: any }) => {
          this.setShowTacModal(true);
          store.dispatch.userModel.setUser({
            confirmedTerms: resp["confirmedTerms"],
          });
          this.setShowTacModal(false);
        });
    },
    async requestContent(rootState: any) {
      this.setShowTacModal(true);
      helpAndLearningAPI
        .requestCMSContent("terms-and-conditions", 1)
        .then((resp: { data: { contentlets: { inode: any }[] } }) => {
          this.setHtmlAndVersionTermsAndConditions({
            html: resp.data.contentlets[0].body,
            versionTermsAndConditions: resp.data.contentlets[0].inode,
          });
        })
        .catch((error: any) => {
          console.log(error);
          this.setHtmlAndVersionTermsAndConditions({
            html: "No Content returned",
            versionTermsAndConditions: "",
          });
        });
    },
  },
};
export default termsAndConditionsModel;
